import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { fmtMoney, DEFAULT_CURRENCY } from "../../lib/money";

/**
 * QENVA · Valeur Préservée Totale™ — full-width navy hero block.
 *
 *  ┌────────────────────────────────────────────────────────────────┐
 *  │ VALEUR PRÉSERVÉE TOTALE™              [Voir le Rapport Exécutif ↗]│
 *  │ 127 400 $                                                      │
 *  │ Valeur potentiellement protégée grâce aux recommandations Guardian™ │
 *  └────────────────────────────────────────────────────────────────┘
 */

export default function TotalPreservedValueBlock({
  value,
  onOpenReport,
  testId = "total-preserved-value",
}) {
  const { t } = useTranslation("dashboard");
  const amount = value?.amount ?? 0;
  const currency = value?.currency || DEFAULT_CURRENCY;

  return (
    <section
      className="relative rounded-2xl overflow-hidden text-white p-6 sm:p-8"
      style={{
        background: "linear-gradient(135deg, #04102A 0%, #0B1B3B 60%, #122E5C 100%)",
      }}
      data-testid={testId}
    >
      {/* dot grid */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="relative flex flex-wrap items-center gap-6 justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-[10.5px] uppercase tracking-[0.16em] font-bold text-emerald-300 mb-2" data-testid={`${testId}-label`}>
            {t("total_preserved.label")}
          </p>
          <p className="font-display font-bold text-white text-[40px] sm:text-[48px] tabular-nums leading-none" data-testid={`${testId}-amount`}>
            {fmtMoney(amount, currency, { compact: false })}
          </p>
          <p className="text-white/65 text-[13px] mt-3 max-w-2xl">
            {t("total_preserved.subtitle")}
          </p>
        </div>
        <button
          type="button"
          onClick={onOpenReport}
          data-testid={`${testId}-report-cta`}
          className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-white/10 hover:bg-white/15 ring-1 ring-white/20 text-white text-[13px] font-bold transition-colors"
        >
          {t("total_preserved.cta")}
          <ArrowUpRight size={14} />
        </button>
      </div>
    </section>
  );
}
